import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {HttpService} from "../http/HttpService";
import {ListSystemEventLogsResponse, Payment} from "../http/protocol";


export class SystemEventService extends AbstractAdminEntityService<Payment, ListSystemEventLogsResponse> {

    constructor(http: HttpService) {
        super("/system-event", http)
    }

    async getCounts(): Promise<{infoEventsCount?: number, warnEventsCount?: number, errorEventsCount?: number}> {
        let url = `${this.entityPath}/counts`;
        return this.http.get(url);
    }

    async resolve(id: number) {
        return this.http.put(this.entityPath + `/resolve/${id}`, id);
    }
}